import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Skip /me if we're returning from OAuth callback (AuthCallback will handle it)
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const loginWithPassword = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    if (res.data?.session_token) {
      localStorage.setItem("jnic_session_token", res.data.session_token);
    }
    if (res.data?.user) {
      setUser(res.data.user);
    }
    return res.data;
  };

  const registerWithPassword = async (name, email, password) => {
    const res = await api.post("/auth/register", { name, email, password });
    if (res.data?.session_token) {
      localStorage.setItem("jnic_session_token", res.data.session_token);
    }
    if (res.data?.user) {
      setUser(res.data.user);
    }
    return res.data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.warn("[AuthContext] logout failed (session may already be expired)", err);
    }
    localStorage.removeItem("jnic_session_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout, checkAuth, loginWithPassword, registerWithPassword }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
};
